// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseSafetyDriverAnnotationsAreaRoutes = {
  route: '/safety-driver-annotations',
}

export const SafetyDriverAnnotationsAreaRoutes = transformRoutes(
  BaseSafetyDriverAnnotationsAreaRoutes,
)
